/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as AuthenticatedBecomeHostRouteImport } from './routes/_authenticated.become-host'
import { Route as AuthenticatedHostRouteImport } from './routes/_authenticated.host'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated.notifications'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated.profile'
import { Route as ListingsListingIdRouteImport } from './routes/listings.$listingId'
import { Route as PropertiesIndexRouteImport } from './routes/properties.index'
import { Route as PropertiesPropertyIdRouteImport } from './routes/properties.$propertyId'
import { Route as AuthenticatedBookingsIndexRouteImport } from './routes/_authenticated.bookings.index'
import { Route as AuthenticatedBookingsBookingIdRouteImport } from './routes/_authenticated.bookings.$bookingId'
import { Route as AuthenticatedChatsIndexRouteImport } from './routes/_authenticated.chats.index'
import { Route as AuthenticatedChatsBookingIdRouteImport } from './routes/_authenticated.chats.$bookingId'
import { Route as AuthenticatedHostIndexRouteImport } from './routes/_authenticated.host.index'
import { Route as AuthenticatedHostCalendarRouteImport } from './routes/_authenticated.host.calendar'
import { Route as AuthenticatedHostBookingsIndexRouteImport } from './routes/_authenticated.host.bookings.index'
import { Route as AuthenticatedHostListingsIndexRouteImport } from './routes/_authenticated.host.listings.index'
import { Route as AuthenticatedHostListingsNewRouteImport } from './routes/_authenticated.host.listings.new'
import { Route as AuthenticatedHostPropertiesIndexRouteImport } from './routes/_authenticated.host.properties.index'
import { Route as AuthenticatedHostPropertiesNewRouteImport } from './routes/_authenticated.host.properties.new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedBecomeHostRoute = AuthenticatedBecomeHostRouteImport.update({
  id: '/become-host',
  path: '/become-host',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHostRoute = AuthenticatedHostRouteImport.update({
  id: '/host',
  path: '/host',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const ListingsListingIdRoute = ListingsListingIdRouteImport.update({
  id: '/listings/$listingId',
  path: '/listings/$listingId',
  getParentRoute: () => rootRouteImport,
} as any)
const PropertiesIndexRoute = PropertiesIndexRouteImport.update({
  id: '/properties/',
  path: '/properties/',
  getParentRoute: () => rootRouteImport,
} as any)
const PropertiesPropertyIdRoute = PropertiesPropertyIdRouteImport.update({
  id: '/properties/$propertyId',
  path: '/properties/$propertyId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedBookingsIndexRoute =
  AuthenticatedBookingsIndexRouteImport.update({
    id: '/bookings/',
    path: '/bookings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBookingsBookingIdRoute =
  AuthenticatedBookingsBookingIdRouteImport.update({
    id: '/bookings/$bookingId',
    path: '/bookings/$bookingId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChatsIndexRoute = AuthenticatedChatsIndexRouteImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChatsBookingIdRoute =
  AuthenticatedChatsBookingIdRouteImport.update({
    id: '/chats/$bookingId',
    path: '/chats/$bookingId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHostIndexRoute = AuthenticatedHostIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedHostRoute,
} as any)
const AuthenticatedHostCalendarRoute =
  AuthenticatedHostCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthenticatedHostRoute,
  } as any)
const AuthenticatedHostBookingsIndexRoute =
  AuthenticatedHostBookingsIndexRouteImport.update({
    id: '/bookings/',
    path: '/bookings/',
    getParentRoute: () => AuthenticatedHostRoute,
  } as any)
const AuthenticatedHostListingsIndexRoute =
  AuthenticatedHostListingsIndexRouteImport.update({
    id: '/listings/',
    path: '/listings/',
    getParentRoute: () => AuthenticatedHostRoute,
  } as any)
const AuthenticatedHostListingsNewRoute =
  AuthenticatedHostListingsNewRouteImport.update({
    id: '/listings/new',
    path: '/listings/new',
    getParentRoute: () => AuthenticatedHostRoute,
  } as any)
const AuthenticatedHostPropertiesIndexRoute =
  AuthenticatedHostPropertiesIndexRouteImport.update({
    id: '/properties/',
    path: '/properties/',
    getParentRoute: () => AuthenticatedHostRoute,
  } as any)
const AuthenticatedHostPropertiesNewRoute =
  AuthenticatedHostPropertiesNewRouteImport.update({
    id: '/properties/new',
    path: '/properties/new',
    getParentRoute: () => AuthenticatedHostRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/become-host': typeof AuthenticatedBecomeHostRoute
  '/host': typeof AuthenticatedHostRouteWithChildren
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/listings/$listingId': typeof ListingsListingIdRoute
  '/properties/$propertyId': typeof PropertiesPropertyIdRoute
  '/properties/': typeof PropertiesIndexRoute
  '/bookings/$bookingId': typeof AuthenticatedBookingsBookingIdRoute
  '/chats/$bookingId': typeof AuthenticatedChatsBookingIdRoute
  '/host/calendar': typeof AuthenticatedHostCalendarRoute
  '/bookings/': typeof AuthenticatedBookingsIndexRoute
  '/chats/': typeof AuthenticatedChatsIndexRoute
  '/host/': typeof AuthenticatedHostIndexRoute
  '/host/listings/new': typeof AuthenticatedHostListingsNewRoute
  '/host/properties/new': typeof AuthenticatedHostPropertiesNewRoute
  '/host/bookings/': typeof AuthenticatedHostBookingsIndexRoute
  '/host/listings/': typeof AuthenticatedHostListingsIndexRoute
  '/host/properties/': typeof AuthenticatedHostPropertiesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/become-host': typeof AuthenticatedBecomeHostRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/listings/$listingId': typeof ListingsListingIdRoute
  '/properties/$propertyId': typeof PropertiesPropertyIdRoute
  '/properties': typeof PropertiesIndexRoute
  '/bookings/$bookingId': typeof AuthenticatedBookingsBookingIdRoute
  '/chats/$bookingId': typeof AuthenticatedChatsBookingIdRoute
  '/host/calendar': typeof AuthenticatedHostCalendarRoute
  '/bookings': typeof AuthenticatedBookingsIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/host': typeof AuthenticatedHostIndexRoute
  '/host/listings/new': typeof AuthenticatedHostListingsNewRoute
  '/host/properties/new': typeof AuthenticatedHostPropertiesNewRoute
  '/host/bookings': typeof AuthenticatedHostBookingsIndexRoute
  '/host/listings': typeof AuthenticatedHostListingsIndexRoute
  '/host/properties': typeof AuthenticatedHostPropertiesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/_authenticated/become-host': typeof AuthenticatedBecomeHostRoute
  '/_authenticated/host': typeof AuthenticatedHostRouteWithChildren
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/listings/$listingId': typeof ListingsListingIdRoute
  '/properties/$propertyId': typeof PropertiesPropertyIdRoute
  '/properties/': typeof PropertiesIndexRoute
  '/_authenticated/bookings/$bookingId': typeof AuthenticatedBookingsBookingIdRoute
  '/_authenticated/chats/$bookingId': typeof AuthenticatedChatsBookingIdRoute
  '/_authenticated/host/calendar': typeof AuthenticatedHostCalendarRoute
  '/_authenticated/bookings/': typeof AuthenticatedBookingsIndexRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexRoute
  '/_authenticated/host/': typeof AuthenticatedHostIndexRoute
  '/_authenticated/host/listings/new': typeof AuthenticatedHostListingsNewRoute
  '/_authenticated/host/properties/new': typeof AuthenticatedHostPropertiesNewRoute
  '/_authenticated/host/bookings/': typeof AuthenticatedHostBookingsIndexRoute
  '/_authenticated/host/listings/': typeof AuthenticatedHostListingsIndexRoute
  '/_authenticated/host/properties/': typeof AuthenticatedHostPropertiesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/register'
    | '/become-host'
    | '/host'
    | '/notifications'
    | '/profile'
    | '/listings/$listingId'
    | '/properties/$propertyId'
    | '/properties/'
    | '/bookings/$bookingId'
    | '/chats/$bookingId'
    | '/host/calendar'
    | '/bookings/'
    | '/chats/'
    | '/host/'
    | '/host/listings/new'
    | '/host/properties/new'
    | '/host/bookings/'
    | '/host/listings/'
    | '/host/properties/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/register'
    | '/become-host'
    | '/notifications'
    | '/profile'
    | '/listings/$listingId'
    | '/properties/$propertyId'
    | '/properties'
    | '/bookings/$bookingId'
    | '/chats/$bookingId'
    | '/host/calendar'
    | '/bookings'
    | '/chats'
    | '/host'
    | '/host/listings/new'
    | '/host/properties/new'
    | '/host/bookings'
    | '/host/listings'
    | '/host/properties'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/register'
    | '/_authenticated/become-host'
    | '/_authenticated/host'
    | '/_authenticated/notifications'
    | '/_authenticated/profile'
    | '/listings/$listingId'
    | '/properties/$propertyId'
    | '/properties/'
    | '/_authenticated/bookings/$bookingId'
    | '/_authenticated/chats/$bookingId'
    | '/_authenticated/host/calendar'
    | '/_authenticated/bookings/'
    | '/_authenticated/chats/'
    | '/_authenticated/host/'
    | '/_authenticated/host/listings/new'
    | '/_authenticated/host/properties/new'
    | '/_authenticated/host/bookings/'
    | '/_authenticated/host/listings/'
    | '/_authenticated/host/properties/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  ListingsListingIdRoute: typeof ListingsListingIdRoute
  PropertiesPropertyIdRoute: typeof PropertiesPropertyIdRoute
  PropertiesIndexRoute: typeof PropertiesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/become-host': {
      id: '/_authenticated/become-host'
      path: '/become-host'
      fullPath: '/become-host'
      preLoaderRoute: typeof AuthenticatedBecomeHostRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/host': {
      id: '/_authenticated/host'
      path: '/host'
      fullPath: '/host'
      preLoaderRoute: typeof AuthenticatedHostRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/listings/$listingId': {
      id: '/listings/$listingId'
      path: '/listings/$listingId'
      fullPath: '/listings/$listingId'
      preLoaderRoute: typeof ListingsListingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/properties/': {
      id: '/properties/'
      path: '/properties'
      fullPath: '/properties/'
      preLoaderRoute: typeof PropertiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/properties/$propertyId': {
      id: '/properties/$propertyId'
      path: '/properties/$propertyId'
      fullPath: '/properties/$propertyId'
      preLoaderRoute: typeof PropertiesPropertyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/bookings/': {
      id: '/_authenticated/bookings/'
      path: '/bookings'
      fullPath: '/bookings/'
      preLoaderRoute: typeof AuthenticatedBookingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bookings/$bookingId': {
      id: '/_authenticated/bookings/$bookingId'
      path: '/bookings/$bookingId'
      fullPath: '/bookings/$bookingId'
      preLoaderRoute: typeof AuthenticatedBookingsBookingIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats/'
      preLoaderRoute: typeof AuthenticatedChatsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chats/$bookingId': {
      id: '/_authenticated/chats/$bookingId'
      path: '/chats/$bookingId'
      fullPath: '/chats/$bookingId'
      preLoaderRoute: typeof AuthenticatedChatsBookingIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/host/': {
      id: '/_authenticated/host/'
      path: '/'
      fullPath: '/host/'
      preLoaderRoute: typeof AuthenticatedHostIndexRouteImport
      parentRoute: typeof AuthenticatedHostRoute
    }
    '/_authenticated/host/calendar': {
      id: '/_authenticated/host/calendar'
      path: '/calendar'
      fullPath: '/host/calendar'
      preLoaderRoute: typeof AuthenticatedHostCalendarRouteImport
      parentRoute: typeof AuthenticatedHostRoute
    }
    '/_authenticated/host/bookings/': {
      id: '/_authenticated/host/bookings/'
      path: '/bookings'
      fullPath: '/host/bookings/'
      preLoaderRoute: typeof AuthenticatedHostBookingsIndexRouteImport
      parentRoute: typeof AuthenticatedHostRoute
    }
    '/_authenticated/host/listings/': {
      id: '/_authenticated/host/listings/'
      path: '/listings'
      fullPath: '/host/listings/'
      preLoaderRoute: typeof AuthenticatedHostListingsIndexRouteImport
      parentRoute: typeof AuthenticatedHostRoute
    }
    '/_authenticated/host/listings/new': {
      id: '/_authenticated/host/listings/new'
      path: '/listings/new'
      fullPath: '/host/listings/new'
      preLoaderRoute: typeof AuthenticatedHostListingsNewRouteImport
      parentRoute: typeof AuthenticatedHostRoute
    }
    '/_authenticated/host/properties/': {
      id: '/_authenticated/host/properties/'
      path: '/properties'
      fullPath: '/host/properties/'
      preLoaderRoute: typeof AuthenticatedHostPropertiesIndexRouteImport
      parentRoute: typeof AuthenticatedHostRoute
    }
    '/_authenticated/host/properties/new': {
      id: '/_authenticated/host/properties/new'
      path: '/properties/new'
      fullPath: '/host/properties/new'
      preLoaderRoute: typeof AuthenticatedHostPropertiesNewRouteImport
      parentRoute: typeof AuthenticatedHostRoute
    }
  }
}

interface AuthenticatedHostRouteChildren {
  AuthenticatedHostCalendarRoute: typeof AuthenticatedHostCalendarRoute
  AuthenticatedHostIndexRoute: typeof AuthenticatedHostIndexRoute
  AuthenticatedHostListingsNewRoute: typeof AuthenticatedHostListingsNewRoute
  AuthenticatedHostPropertiesNewRoute: typeof AuthenticatedHostPropertiesNewRoute
  AuthenticatedHostBookingsIndexRoute: typeof AuthenticatedHostBookingsIndexRoute
  AuthenticatedHostListingsIndexRoute: typeof AuthenticatedHostListingsIndexRoute
  AuthenticatedHostPropertiesIndexRoute: typeof AuthenticatedHostPropertiesIndexRoute
}

const AuthenticatedHostRouteChildren: AuthenticatedHostRouteChildren = {
  AuthenticatedHostCalendarRoute: AuthenticatedHostCalendarRoute,
  AuthenticatedHostIndexRoute: AuthenticatedHostIndexRoute,
  AuthenticatedHostListingsNewRoute: AuthenticatedHostListingsNewRoute,
  AuthenticatedHostPropertiesNewRoute: AuthenticatedHostPropertiesNewRoute,
  AuthenticatedHostBookingsIndexRoute: AuthenticatedHostBookingsIndexRoute,
  AuthenticatedHostListingsIndexRoute: AuthenticatedHostListingsIndexRoute,
  AuthenticatedHostPropertiesIndexRoute: AuthenticatedHostPropertiesIndexRoute,
}

const AuthenticatedHostRouteWithChildren =
  AuthenticatedHostRoute._addFileChildren(AuthenticatedHostRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedBecomeHostRoute: typeof AuthenticatedBecomeHostRoute
  AuthenticatedHostRoute: typeof AuthenticatedHostRouteWithChildren
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedBookingsBookingIdRoute: typeof AuthenticatedBookingsBookingIdRoute
  AuthenticatedChatsBookingIdRoute: typeof AuthenticatedChatsBookingIdRoute
  AuthenticatedBookingsIndexRoute: typeof AuthenticatedBookingsIndexRoute
  AuthenticatedChatsIndexRoute: typeof AuthenticatedChatsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedBecomeHostRoute: AuthenticatedBecomeHostRoute,
  AuthenticatedHostRoute: AuthenticatedHostRouteWithChildren,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedBookingsBookingIdRoute: AuthenticatedBookingsBookingIdRoute,
  AuthenticatedChatsBookingIdRoute: AuthenticatedChatsBookingIdRoute,
  AuthenticatedBookingsIndexRoute: AuthenticatedBookingsIndexRoute,
  AuthenticatedChatsIndexRoute: AuthenticatedChatsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ListingsListingIdRoute: ListingsListingIdRoute,
  PropertiesPropertyIdRoute: PropertiesPropertyIdRoute,
  PropertiesIndexRoute: PropertiesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
